module.exports = __webpack_public_path__ + "img/BatteryCarInfoBgblue.7985bc54.png";